import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=91da5168&scoped=true&"
import script from "./VehicleView.vue?vue&type=script&lang=js&"
export * from "./VehicleView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleView.vue?vue&type=style&index=0&id=91da5168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91da5168",
  null
  
)

export default component.exports